module.exports = __webpack_public_path__ + "img/banner.2acfe436.png";